<template>

    <CascoAjanlatBase :titleExtra="titleExtra">

        <v-form slot="biztositoi-adatok" ref="casco-ajanlat-adatok">

            <v-layout row wrap>

                <BnFormField v-if="elozmenyTipusVisible()" :attributes="this['8_elozmenyTipus']" />

                <BnFormField v-if="elozmenySzamVisible()" :attributes="this['8_elozmenySzam']" />

                <BnFormField v-if="preventorVisible()" :attributes="this['8_groupama_szerz_azon6']" />

                <BnFormField v-if="ajszamVisible()" :attributes="this['8_gfbAjszam']" />

                <BnFormField v-if="szerzSzamVisible()" :attributes="this['8_gfbSzerzszam']" />

                <BnFormField :attributes="this['tf_8_muszakiVizsgaErvenyesseg']" />

               <!-- <template v-if="lakasVisible()">

                    <BnFormField
                        :key="`groupama_szerz_azon2_${index}`"
                        v-for="(x, index) in getLakasDb()"
                        :attributes="{
                        type: 'text',
                        label: 'Lakásbiztosítás szerződés azonosító',
                        visible: true,
                        editable: true,
                        help: false,
                        path: 'tarifaData.groupama.tf_8_groupama_szerz_azon2_' + (x - 1),
                        mezo: 'groupama_szerz_azon2'
                    }"/>

                </template>

                <template v-if="eletVisible()">

                    <BnFormField
                        :key="`groupama_szerz_azon4_${index}`"
                        v-for="(x, index) in getEletDb()"
                        :attributes="{
                        type: 'text',
                        label: 'Életbiztosítás szerződés azonosító',
                        visible: true,
                        editable: true,
                        help: false,
                        path: 'tarifaData.groupama.tf_8_groupama_szerz_azon4_' + (x - 1),
                        mezo: 'groupama_szerz_azon4'
                    }"/>

                </template>

                <template v-if="cascoVisible()">

                    <BnFormField :key="`tf_8_groupama_szerz_azon3_${index}`" v-for="(x, index) in getCascoDb()"
                                 :attributes="{
                        type: 'text',
                        label: 'Cascobiztosítás szerződés azonosító',
                        visible: true,
                        editable: true,
                        help: false,
                        path: 'tarifaData.groupama.tf_8_groupama_szerz_azon3_' + (x - 1),
                        mezo: 'tf_8_groupama_szerz_azon3_' + (x - 1)
                    }"/>
                </template>

                <template v-if="tobbjarmuVisible()">

                    <BnFormField :key="`groupama_szerz_azon5_${index}`" v-for="(x, index) in getTobbautoDb()"
                                 :attributes="{
                        type: 'text',
                        label: 'Másik gépjármű szerződésszáma vagy ajánlatszáma',
                        visible: true,
                        editable: true,
                        help: false,
                        path: 'tarifaData.groupama.tf_8_groupama_szerz_azon5_' + (x - 1),
                        mezo: 'groupama_szerz_azon5'
                    }"/>

                </template> -->

            </v-layout>

        </v-form>

    </CascoAjanlatBase>

</template>

<script>
import { listTypes } from '../../../../../../../../modules/List';
import BnFormField from '../../../../../../../basecomponents/BnFormField.vue';
import CascoAjanlatBase from '../CascoAjanlatBase.vue';
import cascoOfferData from '../../../../../mixins/ajanlatiadatok/biztosito_specifikus/CascoOfferData';

export default {
    components: { CascoAjanlatBase, BnFormField },
    mixins: [cascoOfferData],
    methods: {
        elozmenyVisible() {
            return this.$store.getters.vanCascoBonusz;
        },
        elozmenyTipusVisible() {
            return this.elozmenyVisible() && !!this.groupamasElozmeny;
        },
        elozmenySzamVisible() {
            return this.elozmenyVisible() && parseInt(this.elozmenyTipus, 10) === 2;
        },
        kgfbBiztositoVisible() {
            return false; // TODO::
        },
        ajszamVisible() {
            return false; // TODO::
        },
        szerzSzamVisible() {
            return false; // TODO::
        },
        elozmenyTipusChange() {
            this.elozmenyTipus = this.$store.getters.tarifaData.groupama.tf_8_elozmenyTipus;
        },
        preventorVisible() {
            return this.kedvezmenyek.preventorpartner
                && !this.$store.getters.kedvezmenyekbiztosito?.[this.biztositoid]?.preventor;
        },
        getLakasDb() {
            return this.kedvezmenyek.lakaspartner;
        },
        getEletDb() {
            return this.kedvezmenyek.eletpartner;
        },
        getCascoDb() {
            return this.kedvezmenyek.cascopartner;
        },
        getTobbautoDb() {
            return this.kedvezmenyek.gfbpartner;
        },
        lakasVisible() {
            return this.getLakasDb() > 0;
        },
        eletVisible() {
            return this.getEletDb() > 0;
        },
        cascoVisible() {
            return this.getCascoDb() > 0;
        },
        tobbjarmuVisible() {
            return this.getTobbautoDb() > 0;
        },
    },

    mounted() {
        this.groupamasElozmeny = this.$store.getters.tarifaData.casco_elozo_biztosito === 4;
        this.elozmenyTipus = this.$store.getters.tarifaData?.groupama?.tf_8_elozmenyTipus;
    },

    data() {
        return {
            name: 'AjanlatAdatokB8_V0',
            version: 'v0',
            groupamasElozmeny: false,
            elozmenyTipus: null,
            '8_kgfb_group_munkahely': {
                type: 'select',
                label: 'Munkahely',
                visible: true,
                editable: true,
                help: true,
                path: 'tarifaData.kgfb_group_munkahely',
                mezo: 'kgfb_group_munkahely',
                resource: listTypes.groupama_munkahely, // TODO:: listtype.munkahely,
                itemsText: 'value',
                itemsValue: 'key',
            },
            '8_groupama_szerz_azon6': {
                type: 'text',
                label: 'Preventor vagyon és felelősségbiztosítás szerződésszáma',
                visible: true,
                editable: true,
                help: true,
                mezo: 'tf_8_groupama_szerz_azon6',
                path: 'tarifaData.groupama.tf_8_groupama_szerz_azon6',
            },
            '8_elozmenyGfb': {
                type: 'select',
                label: 'Előzmény casco biztosítása a Groupamánál van?',
                visible: true,
                editable: true,
                help: true,
                mezo: 'groupama.tf_8_elozmenyGfb',
                path: 'tarifaData.groupama.tf_8_elozmenyGfb',
                itemsText: 'key',
                itemsValue: 'value',
                resource: listTypes.yesno,
            },
            '8_elozmenyTipus': {
                type: 'select',
                label: 'Előzmény Groupama casco biztosítás azonosítása',
                visible: true,
                editable: true,
                help: true,
                mezo: 'groupama.tf_8_elozmenyTipus',
                path: 'tarifaData.groupama.tf_8_elozmenyTipus',
                itemsText: 'value',
                itemsValue: 'key',
                options: [
                    { key: '2', value: 'Szerződésszám alapján' },
                    { key: '3', value: 'Azonosító nélkül' },
                ],
                change: this.elozmenyTipusChange,
            },
            '8_elozmenySzam': {
                type: 'text',
                label: 'Előzmény Groupama casco szerződésszáma',
                visible: true,
                editable: true,
                help: true,
                mezo: 'groupama.tf_8_elozmenySzam',
                path: 'tarifaData.groupama.tf_8_elozmenySzam',
            },
            kgfb_biztosito: {
                type: 'select',
                label: 'Kgfb szerződésének biztosítójaa',
                visible: true,
                editable: true,
                help: true,
                mezo: 'kgfb_biztosito',
                path: 'tarifaData.kgfb_biztosito',
                itemsText: 'value',
                itemsValue: 'key',
                resource: listTypes.elozobizt,
            },
            '8_gfbAjszam': {
                type: 'text',
                label: 'Groupama Kgfb ajánlatszáma',
                visible: true,
                editable: true,
                help: true,
                mezo: '8_gfbAjszam',
                path: 'tarifaData.8_gfbAjszam',
            },
            '8_gfbSzerzszam': {
                type: 'text',
                label: 'Groupama Kgfb szerződésszáma',
                visible: true,
                editable: true,
                help: true,
                mezo: '8_gfbSzerzszam',
                path: 'tarifaData.8_gfbSzerzszam',
            },
            tf_8_muszakiVizsgaErvenyesseg: {
                type: 'date',
                label: 'Műszaki vizsga érvényessége',
                visible: true,
                editable: true,
                help: true,
                mezo: 'groupama.tf_8_muszakiVizsgaErvenyesseg',
                path: 'tarifaData.groupama.tf_8_muszakiVizsgaErvenyesseg',
            },
        };
    },
};
</script>
